import chrome from "../assets/icons/device/chrome.png";
import samsung from "../assets/icons/device/samsung.png";
import apple from "../assets/icons/device/apple.png";
import windows from "../assets/icons/device/Windows.png";
import firetv from "../assets/icons/device/firetv.png";
import androidtv from "../assets/icons/device/androidtv.png";
import x96 from "../assets/icons/device/x96.png";
import lg from "../assets/icons/device/lg.png";
import toshiba from "../assets/icons/device/toshiba.png";
import tcl from "../assets/icons/device/tcl.png";
import sharp from "../assets/icons/device/sharp.png";
import sony from "../assets/icons/device/sony.png";
import android from "../assets/icons/device/Android.png";
import xbox from "../assets/icons/device/xbox.png";
import formuler from "../assets/icons/device/formuler.png";
import lenovo from "../assets/icons/device/Lenovo.png";
import philips from "../assets/icons/device/philips.png";
import xiaomi from "../assets/icons/device/xiaomi.png";
import roku from "../assets/icons/device/roku.png";
import ps from "../assets/icons/device/ps.png";
import huawei from "../assets/icons/device/huawei.png";
import hisense from "../assets/icons/device/Hisense.png";
import vizio from "../assets/icons/device/VIZIO.png";
import nvidia from "../assets/icons/device/NVIDIA.png";
import SectionHeading from "../components/SectionHeading";
import Reveal from "../components/Reveal";
import GridTexture from "../components/GridTexture";

const deviceLogos = [
  { name: "Chrome", src: chrome },
  { name: "Samsung", src: samsung },
  { name: "Apple", src: apple },
  { name: "Windows", src: windows },
  { name: "Fire TV", src: firetv },
  { name: "Android TV", src: androidtv },
  { name: "X96", src: x96 },
  { name: "LG", src: lg },
  { name: "Toshiba", src: toshiba },
  { name: "TCL", src: tcl },
  { name: "Sharp", src: sharp },
  { name: "Sony", src: sony },
  { name: "Android", src: android },
  { name: "Xbox", src: xbox },
  { name: "Formuler", src: formuler },
  { name: "Lenovo", src: lenovo },
  { name: "Philips", src: philips },
  { name: "Xiaomi", src: xiaomi },
  { name: "Roku", src: roku },
  { name: "PlayStation", src: ps },
  { name: "Huawei", src: huawei },
  { name: "Hisense", src: hisense },
  { name: "Vizio", src: vizio },
  { name: "NVIDIA", src: nvidia },
];

export default function Device() {
  return (
    <section
      id="devices"
      className="py-14 sm:py-20 bg-surface-primary relative overflow-hidden"
      style={{ "--section-bg": "#000000" }}
    >
      <GridTexture />
      <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto relative">
        <SectionHeading
          kicker="Apparaten"
          title={
            <>
              Compatibele{" "}
              <span className="text-transparent bg-clip-text bg-gradient-text">
                Apparaten
              </span>
            </>
          }
          subtitle="Stream TiviOne op al jouw favoriete apparaten"
        />

        {/* Device Grid — solid white tiles, same treatment as the logo cards elsewhere on the site */}
        <Reveal className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-6 lg:grid-cols-8 gap-2.5 sm:gap-4 mb-10 sm:mb-14">
          {deviceLogos.map((device) => (
            <div
              key={device.name}
              className="group bg-white rounded-lg sm:rounded-xl p-1.5 sm:p-3 border border-white/10 hover:border-accent/40 hover:shadow-glow-cyan-sm transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex items-center justify-center h-6 sm:h-8">
                <img
                  src={device.src}
                  alt={device.name}
                  className="max-h-6 sm:max-h-8 max-w-full object-contain transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </Reveal>

        {/* CTA Button */}
        <div className="text-center">
          <a
            href="#pricing"
            className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 rounded-lg sm:rounded-xl text-white font-bold text-base sm:text-lg shadow-lg bg-gradient-button hover:brightness-110 transition-all duration-300 transform hover:scale-105 min-h-[48px]"
          >
            BEKIJK ONZE ABONNEMENTEN
            <span className="ml-1 sm:ml-2 text-lg sm:text-xl">→</span>
          </a>
        </div>
      </div>
    </section>
  );
}
